import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { Text } from "@/components/ui/baseUi/text"

type BoxLeadFormHeaderProps = {
  isEdition?: boolean
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadFormHeader({ isEdition, className, ...props }: BoxLeadFormHeaderProps) {
  return (
    <div className={cn("mt-6 flex flex-col gap-4", className)} {...props}>
      <Text fontStyle="TL" className="text-textDefault-body">
        {isEdition ? word("box.lead.overview.header.title.edit") : word("box.lead.overview.header.title.add")}
      </Text>
      <Text fontStyle="BS" className="text-textDefault-caption">
        {word("box.lead.overview.header.content.add")}
      </Text>
    </div>
  )
}
